"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _RevieveVirtualTryOn = require("./RevieveVirtualTryOn");
Object.keys(_RevieveVirtualTryOn).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RevieveVirtualTryOn[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _RevieveVirtualTryOn[key];
    }
  });
});
